import React from 'react';
import { useContext, useState } from 'react';
import { CartContext } from '../context/ShopingCartContext';

export const Item = ({ producto }) => {
  const { cart, setCart } = useContext(CartContext);
  const [cantidad, setCantidad] = useState("");
  const [precioAdicion, setPrecioAdicion] = useState("");

  const isInCart = (name) => {
    const exist = cart.findIndex((item) => item.name === name);
    return exist;
  }

  const stateCheck = () => {
    const tieneCart = cart.some(objeto => Object.keys(objeto).indexOf('cart') !== -1);
    return tieneCart ? true : false;
  };

  const addCart = (name, price, id, thumbnail, cantidad, tipoPrecio = "") => {
    let quantity = parseInt(cantidad);
    let finalPrice = parseInt(price);
    const productName = tipoPrecio ? `${name}${tipoPrecio.replace(/\s+/g, '')}` : name;

    if (stateCheck()) {
      let numero = isNaN(quantity) ? 1 : quantity;
      const newItem = { name: productName, price: finalPrice, thumbnail, quantity: numero, id };
      let cartlist = cart[0];
      const exist = cartlist.cart.findIndex((item) => item.name === productName);

      if (exist !== -1) {
        name === "Adicion" || name === "Gaseosa"
          ? (cartlist.cart[exist].price += finalPrice)
          : (cartlist.cart[exist].quantity += numero);
      } else {
        cartlist.cart.push(newItem);
      }
      setCart([cartlist]);
    } else {
      let numero = isNaN(quantity) ? 1 : quantity;
      let items = [...cart];
      const newItem = { name: productName, price: finalPrice, thumbnail, quantity: numero, id };

      if (isInCart(productName) !== -1) {
        name === "Adicion" || name === "Gaseosa"
          ? (items[isInCart(productName)].price += finalPrice)
          : (items[isInCart(productName)].quantity += numero);
      } else {
        items.push(newItem);
      }
      setCart(items);
    }
    setCantidad("");
    setPrecioAdicion("");
  };

  // Función para generar botones según el tipo de precios
  const renderPriceButtons = () => {
    if (producto.nombre === 'Adicion' || producto.nombre === 'Arma Waffle' ||  producto.nombre === 'Arma Oblea' ||  producto.nombre === 'Nevera Crem Helado' ||  producto.nombre === 'Desechable') {
      return (
        <div className="product-actions">
          <input
            type="number"
            value={precioAdicion}
            onChange={(e) => setPrecioAdicion(e.target.value)}
            className="price-input"
            placeholder="Ingrese el precio"
          />
          <button
            type="button"
            className="add-button"
            onClick={() => addCart(producto.nombre, precioAdicion, producto.id, producto.thumbnail, cantidad)}
          >
            Añadir
          </button>
        </div>
      );
    } else if (producto.precio !== undefined) {
      // Productos con precio único
      return (
        <div className="product-actions">
          <div className="quantity-control">
            <input
              type="number"
              value={cantidad}
              onChange={(e) => setCantidad(e.target.value)}
              placeholder="Cantidad"
              className="quantity-input"
              min="1"
            />
          </div>
          <button
            type="button"
            className="add-button"
            onClick={() => addCart(producto.nombre, producto.precio, producto.id, producto.thumbnail, cantidad)}
          >
            {producto.nombre}
          </button>
        </div>
      );
    } else if (producto.precios) {
      // Productos con múltiples precios
      return (
        <>
          <div className="quantity-control">
            <input
              type="number"
              value={cantidad}
              onChange={(e) => setCantidad(e.target.value)}
              placeholder="Cantidad"
              className="quantity-input"
              min="1"
            />
          </div>
          <div className="price-buttons-container">
            {producto.precios.map((precioObj, index) => {
              return Object.entries(precioObj).map(([tipoPrec, valor]) => {
                // Si el valor es un objeto (caso de Helado Tradicional)
                if (typeof valor === 'object') {
                  return Object.entries(valor).map(([subtipo, precio], subindex) => {
                    const btnClass = subindex % 3;
                    return (
                      <button
                        key={`${tipoPrec}-${subtipo}-${subindex}`}
                        type="button"
                        className={`price-button price-button-${btnClass}`}
                        onClick={() => addCart(producto.nombre, precio, producto.id, producto.thumbnail, cantidad, `${tipoPrec}${subtipo}`)}
                      >
                        {`${tipoPrec} ${subtipo}`}
                      </button>
                    );
                  });
                } else {
                  // Caso normal con precio directo
                  const btnClass = index % 3;
                  return (
                    <button
                      key={`${tipoPrec}-${index}`}
                      type="button"
                      className={`price-button price-button-${btnClass}`}
                      onClick={() => addCart(producto.nombre, valor, producto.id, producto.thumbnail, cantidad, tipoPrec)}
                    >
                      {tipoPrec}
                    </button>
                  );
                }
              });
            })}
          </div>
        </>
      );
    }
    return null;
  };

  return (
    <div className="product-card">
      <div key={producto.id} className="product-card-item">
        <div className="product-image-container">
          <img
            src={producto.thumbnail}
            alt={producto.nombre}
            className="product-image"
          />
        </div>
        <div className="product-info">
          <h3 className="product-title">{producto.nombre}</h3>
          
          {renderPriceButtons()}
        </div>
      </div>
      
      <style jsx>{`
        .product-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          margin-bottom: 16px;
          overflow: hidden;
          transition: transform 0.3s ease;
        }
        
        .product-card:hover {
          transform: translateY(-3px);
        }
        
        .product-card-item {
          display: flex;
          align-items: center;
          padding: 16px;
        }
        
        .product-image-container {
          width: 80px;
          height: 80px;
          overflow: hidden;
          border-radius: 8px;
          flex-shrink: 0;
        }
        
        .product-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .product-info {
          flex: 1;
          padding-left: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        
        .product-title {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          text-align: center;
          width: 100%;
        }
        
        .price-buttons-container {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 12px;
          justify-content: center;
        }
        
        .price-button {
          padding: 10px 16px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          color: white;
          transition: all 0.2s ease;
          flex-grow: 0;
          text-align: center;
          min-width: 100px;
        }
        
        .price-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        
        .price-button-0 {
          background-color: #4361ee;
        }
        
        .price-button-1 {
          background-color: #3a0ca3;
        }
        
        .price-button-2 {
          background-color: #7209b7;
        }
        
        .add-button {
          padding: 10px 16px;
          background-color: #4361ee;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.2s ease;
          margin-top: 10px;
          width: 100%;
          max-width: 200px;
        }
        
        .add-button:hover {
          background-color: #3a0ca3;
          transform: translateY(-2px);
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        
        .price-input {
          width: 100%;
          max-width: 200px;
          padding: 10px;
          border: 1px solid #e0e0e0;
          border-radius: 6px;
          margin-bottom: 10px;
        }
        
        .product-actions {
          margin-top: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }
        
        .quantity-control {
          margin-bottom: 10px;
          width: 100%;
          display: flex;
          justify-content: center;
        }
        
        .quantity-input {
          width: 100px;
          text-align: center;
          padding: 8px;
          border: 1px solid #e0e0e0;
          border-radius: 6px;
        }
      `}</style>
    </div>
  );
};